// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

import { useSession } from '../session-context.js';
import { VaultListSection } from './home.js';
import '../styles/home.css';

/** F17.2: dedicated /vaults route so users don't have to bounce off
 *  Home post-vault-open. The page is intentionally minimal — it
 *  reuses the same `VaultListSection` the Home dashboard uses, with
 *  the empty-state copy adjusted to match the user's mental model
 *  ("I came here to see my strategies").
 *
 *  COB-486 §5: the surface is named **Strategies** — that is the offering
 *  the user buys into. "Vault" stays the custody object (a strategy is held
 *  in one), so the vault-detail page and the route `/vaults` are unchanged;
 *  only the section/offering noun moved. */
export function Vaults() {
  const session = useSession();

  if (!session.isAuthenticated) {
    return (
      <div class="vaults-page">
        <h1 class="vaults-page-title">Your strategies</h1>
        <p class="vault-list-empty">Log in to view your strategies.</p>
      </div>
    );
  }

  return (
    <div class="vaults-page">
      <header class="vaults-page-header">
        <div class="vaults-page-heading">
          <h1 class="vaults-page-title">Your strategies</h1>
          <p class="vaults-page-subtitle">
            Each strategy is its own vault · all 2-of-3, you hold one key
          </p>
        </div>
        <a class="vaults-page-open" href="/">
          Start a strategy <span aria-hidden="true">→</span>
        </a>
      </header>
      <VaultListSection
        portfolioSummary
        emptyMessage={
          <p>No strategies yet — accept an offer to start one.</p>
        }
      />
    </div>
  );
}
